<div class="app align-items-center login-background">
  <div class="login-header">
    <img class="login-page-logo mx-4" [src]="logo$ | async">
  </div>

  <beaconstac-wait-loader *ngIf="isLoading" class="beaconstac-overlay full-layout"></beaconstac-wait-loader>

</div>
